import React from 'react';
import { Tag } from '@ver-uds/react';
import { AccountStatus } from 'eve-account-client';

export type AccountStatusTagProps = {
  status: AccountStatus;
  className?: string;
  size?: 'large' | undefined;
};

const getTagVariantForAccountStatus = (status: AccountStatus) => {
  switch (status) {
    case AccountStatus.ACTIVE:
      return 'success';
    case AccountStatus.REJECTED:
      return 'error';
    case AccountStatus.PENDING:
    case AccountStatus.PENDINGMATCH:
    case AccountStatus.PENDINGDUPLICATE:
    case AccountStatus.PENDINGMATCHANDDUPLICATE:
      return 'primary';
    case AccountStatus.TERMINATIONREQUESTED:
      return 'warning';
    case AccountStatus.TERMINATED:
    default:
      return undefined;
  }
};

const AccountStatusTag = ({ status, className, size }: AccountStatusTagProps): JSX.Element => {
  return (
    <Tag size={size} className={className} variant={getTagVariantForAccountStatus(status)}>
      {status.replace(/_/g, ' ')}
    </Tag>
  );
};

export default AccountStatusTag;
